/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Env
 */
export interface Env {
    /**
     * 
     * @type {string}
     * @memberof Env
     */
    operatorMobileDate: string;
    /**
     * 
     * @type {number}
     * @memberof Env
     */
    operatorMobileNbline: number;
    /**
     * 
     * @type {string}
     * @memberof Env
     */
    operatorMobileCompetitorName: string;
    /**
     * 
     * @type {string}
     * @memberof Env
     */
    operatorFixeDate: string;
    /**
     * 
     * @type {number}
     * @memberof Env
     */
    operatorFixeNbline: number;
    /**
     * 
     * @type {string}
     * @memberof Env
     */
    operatorFixeCompetitorName: string;
    /**
     * 
     * @type {string}
     * @memberof Env
     */
    operatorDataDate: string;
    /**
     * 
     * @type {string}
     * @memberof Env
     */
    operatorDataTechnology: string;
    /**
     * 
     * @type {string}
     * @memberof Env
     */
    operatorDataCompetitorName: string;
    /**
     * 
     * @type {string}
     * @memberof Env
     */
    integratorDate: string;
    /**
     * 
     * @type {number}
     * @memberof Env
     */
    integratorNbchannel: number;
    /**
     * 
     * @type {string}
     * @memberof Env
     */
    integratorCompetitorName: string;
}

/**
 * Check if a given object implements the Env interface.
 */
export function instanceOfEnv(value: object): value is Env {
    if (!('operatorMobileDate' in value) || value['operatorMobileDate'] === undefined) return false;
    if (!('operatorMobileNbline' in value) || value['operatorMobileNbline'] === undefined) return false;
    if (!('operatorMobileCompetitorName' in value) || value['operatorMobileCompetitorName'] === undefined) return false;
    if (!('operatorFixeDate' in value) || value['operatorFixeDate'] === undefined) return false;
    if (!('operatorFixeNbline' in value) || value['operatorFixeNbline'] === undefined) return false;
    if (!('operatorFixeCompetitorName' in value) || value['operatorFixeCompetitorName'] === undefined) return false;
    if (!('operatorDataDate' in value) || value['operatorDataDate'] === undefined) return false;
    if (!('operatorDataTechnology' in value) || value['operatorDataTechnology'] === undefined) return false;
    if (!('operatorDataCompetitorName' in value) || value['operatorDataCompetitorName'] === undefined) return false;
    if (!('integratorDate' in value) || value['integratorDate'] === undefined) return false;
    if (!('integratorNbchannel' in value) || value['integratorNbchannel'] === undefined) return false;
    if (!('integratorCompetitorName' in value) || value['integratorCompetitorName'] === undefined) return false;
    return true;
}

export function EnvFromJSON(json: any): Env {
    return EnvFromJSONTyped(json, false);
}

export function EnvFromJSONTyped(json: any, ignoreDiscriminator: boolean): Env {
    if (json == null) {
        return json;
    }
    return {
        
        'operatorMobileDate': json['operator_mobile_date'],
        'operatorMobileNbline': json['operator_mobile_nbline'],
        'operatorMobileCompetitorName': json['operator_mobile_competitor_name'],
        'operatorFixeDate': json['operator_fixe_date'],
        'operatorFixeNbline': json['operator_fixe_nbline'],
        'operatorFixeCompetitorName': json['operator_fixe_competitor_name'],
        'operatorDataDate': json['operator_data_date'],
        'operatorDataTechnology': json['operator_data_Technology'],
        'operatorDataCompetitorName': json['operator_data_competitor_name'],
        'integratorDate': json['integrator_date'],
        'integratorNbchannel': json['integrator_nbchannel'],
        'integratorCompetitorName': json['integrator_competitor_name'],
    };
}

export function EnvToJSON(json: any): Env {
    return EnvToJSONTyped(json, false);
}

export function EnvToJSONTyped(value?: Env | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operator_mobile_date': value['operatorMobileDate'],
        'operator_mobile_nbline': value['operatorMobileNbline'],
        'operator_mobile_competitor_name': value['operatorMobileCompetitorName'],
        'operator_fixe_date': value['operatorFixeDate'],
        'operator_fixe_nbline': value['operatorFixeNbline'],
        'operator_fixe_competitor_name': value['operatorFixeCompetitorName'],
        'operator_data_date': value['operatorDataDate'],
        'operator_data_Technology': value['operatorDataTechnology'],
        'operator_data_competitor_name': value['operatorDataCompetitorName'],
        'integrator_date': value['integratorDate'],
        'integrator_nbchannel': value['integratorNbchannel'],
        'integrator_competitor_name': value['integratorCompetitorName'],
    };
}

